export default {
  data() {
    return {
      lastRequest: null,
      pagination: {
        getData: () => null,
        onChange: () => null,
        backendPaginated: false,
        page: 0,
        maxElement: 5,
        maxPage: 0,
        totalLength: 0,
      },
      sort: {
        sortKey: 0,
        sortColumn: null,
        colName: null,
      },
      inputFilter: '',
    };
  },

  created() {
    const { p } = this.$route.query;
    if (p) {
      this.pagination.page = Number(p) - 1;
    }
  },

  async mounted() {
    await this.setUpMixin();
  },

  computed: {
    tableValues() {
      if (this.loading) return [];
      if (this.tableMixinConfig.backendPaginated) return this.values;
      let data = JSON.parse(JSON.stringify(this.values));
      this.pagination.totalLength = data.length;

      if (data.length > this.pagination.maxElement) {
        data = data.slice(
          this.pagination.maxElement * this.pagination.page,
          this.pagination.page === 0 ? this.pagination.maxElement : this.pagination.maxElement * this.pagination.page + this.pagination.maxElement,
        );
      }

      return data || [];
    },
    pages() {
      let pageNumbers = [];
      let maxPage = this.pagination.maxPage;
      let page = this.pagination.page;

      if (maxPage < 8) {
        for (let index = 0; index < maxPage; index++) pageNumbers.push(index);
        return pageNumbers;
      }

      if (page < 4 && page < maxPage - 4) for (let index = 0; index < 5; index++) pageNumbers.push(index);
      else if (page >= maxPage - 4) for (let index = maxPage - 5 < 0 ? 0 : maxPage - 5; index < maxPage; index++) pageNumbers.push(index);
      else for (let index = page - 1; index < page + 2; index++) pageNumbers.push(index);

      return pageNumbers;
    },
  },
  methods: {
    async setUpMixin() {
      if (!this.tableMixinConfig) return;
      if (!this.tableMixinConfig.backendPaginated) {
        if (this.tableMixinConfig.disablePagination) return;
        const result = await this.getData(this.pagination.page, this.pagination.maxElement);
        this.pagination.maxElement = this.tableMixinConfig.maxElement;
        this.pagination.onChange = this.tableMixinConfig.onChange;
        this.pagination.backendPaginated = this.tableMixinConfig.backendPaginated;
        this.lastRequest = result;
        this.pagination.totalLength = result.length;
        this.pagination.maxPage = Math.ceil(result.data.length / this.tableMixinConfig.maxElement);
        return;
      }
      this.loading = true;
      this.pagination.maxElement = this.tableMixinConfig.maxElement;
      this.pagination.onChange = this.tableMixinConfig.onChange;
      this.pagination.getData = this.tableMixinConfig.getData;
      this.pagination.backendPaginated = this.tableMixinConfig.backendPaginated;
      const result = await this.getData(this.pagination.page, this.pagination.maxElement);
      if (!result || !result.data) {
        return;
      }
      this.lastRequest = result;
      this.pagination.totalLength = result.data.count;
      this.pagination.maxPage = Math.ceil(this.pagination.totalLength / this.pagination.maxElement);
      this.pagination.onChange?.(result.data);
      this.loading = false;
    },
    async resetMixin() {
      this.pagination.page = 0;
      this.setUpMixin();
    },
    setPage(page) {
      this.$router.query = { ...this.$route.query, p: page + 1 };

      if ((page === this.pagination.maxPage && this.pagination.page === this.pagination.maxPage - 1) || (page === -1 && this.pagination.page === 0)) return;
      if (page >= 0 && page < this.pagination.maxPage) this.pagination.page = page;
      this.setUpMixin();
      this.pagination.onChange?.(this.pagination);
    },
    disableDots() {
      if (!this.tableMixinConfig.backendPaginated) return;
      return this.pagination.maxPage <= 8;
    },
    setMaxElement(number) {
      if (!this.tableMixinConfig.backendPaginated) return;
      this.pagination.maxElement = number;
    },
  },
};
